import { useInView } from 'react-intersection-observer';

export const useLoadMoreOnScroll = (hasNextPage: boolean, isFetchingNextPage: boolean, fetchNextPage: () => void) => {
  const { ref } = useInView({
    onChange: (nowInView) => {
      if (nowInView && hasNextPage && !isFetchingNextPage) fetchNextPage();
    },
  });

  return { ref };
};
